import { useRef, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { toast } from 'react-toastify';

// @mui
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem, Avatar, IconButton } from '@mui/material';
// components
import MenuPopover from '../../components/MenuPopover';
import Iconify from '../../components/Iconify';
// mocks_
import account from '../../_mock/account';
import { removeUserFromLocalStorage } from '../../utils/localStorage';
import { useAuth } from '../../context/AuthContext';
import { useSettings } from '../../context/SettingsContext';
import { THEME_OPTIONS } from '../../theme/presets';
import DashboardUserService from '../../services/DashboardUserService';
import PopUpDialog from '../../components/PopUpDialog';
import ChangePasswordForm from './ChangePasswordForm';

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'Home',
    icon: 'eva:home-fill',
    linkTo: '/',
  }
];


function getChangePasswordFormValues(data) {
  return {
    _id: data?._id || '',
    current_password: '',
    new_password: '',
  };
}
// ----------------------------------------------------------------------

export default function AccountPopover() {
  const { authState } = useAuth()
  const { themeColor, setThemeColor } = useSettings();
  const anchorRef = useRef(null);
  const [changePasswordFormValue, setChangePasswordFormValue] = useState(getChangePasswordFormValues());
  const [openChangePasswordForm, setOpenChangePasswordForm] = useState(false);
  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };
  const handleLogout = async () => {
    await DashboardUserService.logout({});
    removeUserFromLocalStorage();
    window.location = '/login?message=You are Logged Out';
    // authDispatch({type:'LOGOUT'})
  };

  const handleChangePassword = async (values) => {
    try {
      const response = await DashboardUserService.changeAdminOwnPassword(values);
      toast.success(response.data.message);
      setOpenChangePasswordForm(false);
      setChangePasswordFormValue(getChangePasswordFormValues());
    } catch (error) {
      const message = error.response && error.response.data.message ? error.response.data.message : error.message;
      toast.error(message);
    }
  };

  const openChangePasswordPopUp = (customer) => {
    setChangePasswordFormValue(getChangePasswordFormValues(customer));
    setOpenChangePasswordForm(true);
  };

  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Avatar src={account.photoURL} alt="photoURL" />
      </IconButton>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1.5,
          ml: 0.75,
          '& .MuiMenuItem-root': {
            typography: 'body2',
            borderRadius: 0.75,
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {authState.user?.name}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {authState.user?.email}
          </Typography>
        </Box>

        {/* <Divider sx={{ borderStyle: 'dashed' }} />
        <Stack>
          {MENU_OPTIONS.map((option) => (
            <MenuItem key={option.label} to={option.linkTo} component={RouterLink} onClick={handleClose}>
              {option.label}
            </MenuItem>
          ))}
        </Stack> */}

        <Divider sx={{ borderStyle: 'dashed' }} />
        <MenuItem onClick={openChangePasswordPopUp}>
          Change Password
        </MenuItem>

        <Divider sx={{ borderStyle: 'dashed' }} />
        <MenuItem onClick={handleLogout}>
          Logout
        </MenuItem>

        <Divider sx={{ borderStyle: 'dashed' }} />
        <Box sx={{ px: 2.5, py: 1.5 }}>
          <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mb: 1 }}>
            Theme
          </Typography>
          <Stack direction="row" spacing={1.5}>
            {THEME_OPTIONS.map((option) => {
              const isActive = themeColor === option.value;
              return (
                <Box
                  key={option.value}
                  onClick={() => setThemeColor(option.value)}
                  title={option.label}
                  sx={{
                    width: 26,
                    height: 26,
                    borderRadius: '50%',
                    bgcolor: option.color,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'transform 0.15s ease',
                    transform: isActive ? 'scale(1.15)' : 'none',
                    boxShadow: (theme) =>
                      isActive ? `0 0 0 2px ${theme.palette.background.paper}, 0 0 0 4px ${option.color}` : 'none',
                    '&:hover': { transform: 'scale(1.15)' },
                  }}
                >
                  {isActive && <Iconify icon="eva:checkmark-fill" sx={{ color: '#fff', width: 16, height: 16 }} />}
                </Box>
              );
            })}
          </Stack>
        </Box>

      </MenuPopover>

      <PopUpDialog openPopup={openChangePasswordForm} closePopup={() => setOpenChangePasswordForm(false)} title={'Change Password'}>
        <ChangePasswordForm
          formValues={changePasswordFormValue}
          handleChangePassword={handleChangePassword}
          closePopup={() => setOpenChangePasswordForm(false)}
          resetFormValues={() => {
            setChangePasswordFormValue(getChangePasswordFormValues());
          }}
        />
      </PopUpDialog>
    </>
  );
}
